import { FC, useEffect } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Hooks
import { Direction, useSortableItems } from 'hooks/useSortableItems';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { getActiveQuizzes } from 'store/quiz/quizzesAsync';
import { setInitialField } from 'store/quiz/quizzesSlice';
import { selectActiveQuizzes } from 'store/quiz/quizzesSelectors';
// Components
import { Toolbar } from 'components/Toolbar';
import QuizzesSortSidebar from './QuizzesSort';
import QuizzesList from './QuizzesList';

const initialConfig = { key: 'quizName', direction: Direction.Ascending }

const ActiveQuizzes: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const quizzes = useAppSelector(selectActiveQuizzes);

  const { items, sortConfig, requestSort, getClassNamesFor } = useSortableItems(
    quizzes, initialConfig
  );

  useEffect(() => {
    dispatch(getActiveQuizzes({}));

    return () => {
      dispatch(setInitialField('activeQuizzes'));
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container max-w-screen-desktop flex-grow py-4 overflow-y-auto">
      <Toolbar className="items-center gap-2" title={t('pages.activeQuizzes.title')}>
        <div
          className="
            flex items-center
            order-2 lg:order-none
            w-full lg:w-auto
            mt-4 lg:mt-0
          "
        >
          <QuizzesSortSidebar
            sortConfig={sortConfig || initialConfig}
            onRequestSort={requestSort}
          />
        </div>
      </Toolbar>
      <QuizzesList
        sortedQuizzes={items}
        onRequestSort={requestSort}
        getClassNamesFor={getClassNamesFor}
      />
    </div>
  );
}

export default ActiveQuizzes;
